module.exports = __webpack_public_path__ + "f32809824090342e6626287c7b98ad73.svg";